import {cloneDeep} from 'lodash';
import {
	GET_PERSONAL_CONTENT, UPDATE_PERSONAL_ITEM, RESET_PERSONAL_CONTENT,
} from '../constants';

const getPersonalContentAction = (psData, dataType) => (
	{
		type: GET_PERSONAL_CONTENT,
		psData,
		dataType,
	}
);

const updateItemPersonAction = (contentId, psType, psValue, dataType) => (
	{
		type: UPDATE_PERSONAL_ITEM,
		contentId,
		psType,
		psValue,
		dataType,
	}
);

const resetPersonalContentAction = () => (
		{
			type: RESET_PERSONAL_CONTENT,
		}
);

const completeContent = (data, ids, dataType) => {
	const newData = {...cloneDeep(data)};
	const newContentArr = [];
	for (let i = 0; i < ids.length; i += 1) {
		let hasFound = false;
		for (let j = 0; j < data.contents.length; j += 1) {
			if (ids[i] && ids[i].toString() === data.contents[j].id.toString()) {
				hasFound = true;
			}
		}
		if (!hasFound && ids[i]) {
			newContentArr[newContentArr.length] = {
				type: dataType,
				id: ids[i].toString(),
			};
		}
	}
	newData.contents = [...newData.contents, ...newContentArr];
	return newData;
};

export const getPersonalContent = (ids, dataType,
	successCallback, errorCallback) => (dispatch, getState) => {
	const {client: {data: {hasPs}}} = getState();
	if (hasPs) {
		window.ps.personalContent.list(null, dataType, ids, (data) => {
			dispatch(getPersonalContentAction(completeContent(data, ids, dataType), dataType));
			if (successCallback) {
				successCallback(completeContent(data, ids, dataType));
			}
		}, errorCallback, false);
	}
};

export const setItemPersonal = (
		contentId, psType, psValue, dataType, successCallback, errorCallback,
	) => (dispatch, getState) => {
	const {client: {data: {hasPs}}} = getState();
	if (hasPs && window.ps) {
		if (psType === 'playlist') {
			if (psValue) {
				window.ps[psType].addItem(null, dataType, contentId, null, () => {
					dispatch(updateItemPersonAction(contentId, psType, true, dataType));
					if (successCallback) {
						successCallback();
					}
				}, errorCallback);
			} else {
				window.ps[psType].removeItem(null, dataType, contentId, null, () => {
					dispatch(updateItemPersonAction(contentId, psType, false, dataType));
					if (successCallback) {
						successCallback();
					}
				}, errorCallback);
			}
		} else if (psValue) {
			window.ps[psType].set(null, dataType, contentId, () => {
				dispatch(updateItemPersonAction(contentId, psType, true, dataType));
				if (successCallback) {
					successCallback();
				}
			}, errorCallback);
		} else {
			window.ps[psType].remove(null, dataType, contentId, () => {
				dispatch(updateItemPersonAction(contentId, psType, false, dataType));
				if (successCallback) {
					successCallback();
				}
			}, errorCallback);
		}
	}
};

export const resetPersonalContent = () => (dispatch) => {
	dispatch(resetPersonalContentAction());
};
